import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Plus, Truck, ArrowLeft } from 'lucide-react';

const BottlingPlanToolbar = ({ onAddNew }) => {
    const navigate = useNavigate();

    return (
        <div className="sticky-top bg-light border-bottom" style={{ top: '0', zIndex: 1020 }}>
            <div className="container-fluid py-2">
                <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                        <Truck size={24} className="me-2" />
                        <h5 className="mb-0">Bottling Plans</h5>
                    </div>
                    <div className="d-flex align-items-center">
                        <div className="btn-group">
                            <button 
                                className="btn btn-outline-secondary"
                                onClick={() => navigate(-1)}
                                title="Back"
                            >
                                <ArrowLeft size={18} />
                            </button>
                            <button 
                                className="btn btn-outline-secondary"
                                onClick={onAddNew}
                                title="Create New Plan"
                            >
                                <Plus size={18} />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            {/* Inline styles for button SVG animations */}
            <style jsx>{`
                .btn svg {
                    vertical-align: middle;
                    margin-top: -2px;
                }
                .btn:hover svg {
                    transform: scale(1.1);
                    transition: transform 0.2s ease;
                }
                .btn:active svg {
                    transform: scale(0.95);
                }
            `}</style>
        </div>
    );
};

export default BottlingPlanToolbar;